import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { ConfirmResult } from '../../types/payment-element/models';

/** ONE-TIME */
export const OneTimePaymentActions = createActionGroup({
  source: 'PaymentElement - OneTime',
  events: {
    'Set Client Secret': props<{ clientSecret: string | null }>(),
    'Set Active': props<{ active: boolean }>(),

    'View Entered': props<{ containerId: string }>(),
    'View Exited': emptyProps(),

    'Mount Requested': emptyProps(),
    Mounted: props<{ mountedFor: string }>(),
    'Mount Failed': props<{ message: string }>(),
    Unmounted: emptyProps(),

    'Confirm Requested': emptyProps(),
    'Confirm Reset': emptyProps(),
    'Confirm Succeeded': props<{ result: ConfirmResult }>(),
    'Confirm Failed': props<{ error: unknown }>(),
  },
});

/** RECURRING */
export const RecurringPaymentActions = createActionGroup({
  source: 'PaymentElement - Recurring',
  events: {
    'Set Client Secret': props<{ clientSecret: string | null }>(),
    'Set Active': props<{ active: boolean }>(),

    'View Entered': props<{ containerId: string }>(),
    'View Exited': emptyProps(),

    'Mount Requested': emptyProps(),
    Mounted: props<{ mountedFor: string }>(),
    'Mount Failed': props<{ message: string }>(),
    Unmounted: emptyProps(),

    'Confirm Requested': emptyProps(),
    'Confirm Reset': emptyProps(),
    'Confirm Succeeded': props<{ result: ConfirmResult }>(),
    'Confirm Failed': props<{ error: unknown }>(),
  },
});
